export default __webpack_public_path__ + "static/media/laconic_big.a5585d92.jpg";